<!-- .block-products-carousel -->
<div class="block-products-carousel mb-4" [ngClass]="{
        'block-products-carousel--loading': blockProductCarouselService.loading,
        'block-products-carousel--has-items': !!columns?.length
    }" [attr.data-layout]="'grid-'">
    <ng-container *ngIf="layout == 'custom' || layout == 'card-3' || layout== 'grid'">
        <app-block-header [headerIcon]="headerIcon" [name]="translateHelper.localize(name)" [arrows]="true" (next)="carousel.next()" (prev)="carousel.prev()"></app-block-header>
        <div class="block-products-carousel__slider">
            <div class="block-products-carousel__preloader"></div>

            <owl-carousel-o class="owl-slider-item" [options]="carouselOptions" appOwlPreventClick #carousel>
                <ng-template *ngFor="let column of columns" carouselSlide  [width]="layout=='card-3'?277:undefined">
                    <div class="block-products-carousel__column">
                        <div *ngFor="let product of column" class="block-products-carousel__cell">
                            <app-product-card-new class="background-colors" [layout]="layout" [product]="product" style="width: 100%;"></app-product-card-new>
                        </div>
                    </div>
                </ng-template>
            </owl-carousel-o>
        </div>
    </ng-container>
    <ng-container *ngIf="layout == 'card-2'">
        <div class="block-products-carousel__slider">
            <div class="block-products-carousel__preloader"></div>

            <div class="flex flex-row items-center slider">
                <mat-icon matRipple [matRippleCentered]="true" [matRippleRadius]="25" class="shrink-0 arrow-icon cursor-pointer" svgIcon="left-arrow" (click)="carousel.prev()"></mat-icon>
                <div class="flex-auto slider-template justify-center">
                    <owl-carousel-o class="owl-slider-item" [options]="carouselOptions" appOwlPreventClick #carousel>
                        <ng-template *ngFor="let column of columns" carouselSlide>
                            <div class="block-products-carousel__column">
                                <div *ngFor="let product of column" class="block-products-carousel__cell">
                                    <app-product-card-new class="background-colors" [tag]="tag" [layout]="layout" [product]="product" style="width: 100%;"></app-product-card-new>
                                </div>
                            </div>
                        </ng-template>
                    </owl-carousel-o>
                </div>
                <mat-icon matRipple [matRippleCentered]="true" [matRippleRadius]="25" class="shrink-0 arrow-icon cursor-pointer" svgIcon="right-arrow" (click)="carousel.next()"></mat-icon>
            </div>
        </div>
    </ng-container>

</div>



<!-- .block-products-carousel / end -->